import { getPasswordMessage, MINIMUM_PASSWORD_LENGTH } from "@ac-expo/utils";
import {
  sirenOrSiretSchema,
  vatSchema,
  validateVatWithSiren,
} from "@ac-expo/api";
import { z } from "zod";

export const SignupSchema = z
  .object({
    isProfessional: z.boolean(),
    firstName: z
      .string()
      .min(2, "Veuillez entrer un prénom valide")
      .max(64, "Veuillez entrer un prénom valide"),
    lastName: z
      .string()
      .min(2, "Veuillez entrer un nom valide")
      .max(64, "Veuillez entrer un nom valide"),
    email: z.string().email("Veuillez entrer un email valide"),
    siret: sirenOrSiretSchema.optional(),
    vat: vatSchema.optional(),
    businessName: z.string().optional(),
    country: z.string().optional(),
    password: z.string().superRefine((val, ctx) => {
      if (
        val.length < MINIMUM_PASSWORD_LENGTH ||
        !/[a-z]/.test(val) ||
        !/[A-Z]/.test(val) ||
        !/[ !"#$%&'()*+,\-./:;<=>?@[\]^_`{|}~]/.test(val) ||
        !/[0-9]/.test(val)
      ) {
        return ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: getPasswordMessage(val),
        });
      }
    }),
    acceptedTerms: z
      .boolean()
      .refine((val) => val, "Veuillez accepter les conditions d'utilisation"),
  })
  .superRefine((val, ctx) => {
    if (val.isProfessional && !val.country) {
      return ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Veuillez sélectionner un pays",
        path: ["country"],
      });
    }
    validateVatWithSiren(ctx, val.vat, val.siret);
  });

export const defaultSignupValues = {
  firstName: "",
  lastName: "",
  businessName: "",
  siret: "",
  vat: "",
  country: "",
  email: "",
  password: "",
  acceptedTerms: false,
  roles: [],
};

export type SignupForm = z.infer<typeof SignupSchema>;
